export default "__VITE_ASSET__BgFSlUqj__"